import { Col, SelectField } from '@/components';
import { useCurrentFiscalYear } from '@/features/search/_hooks/get-current-fiscal-year';
import {
  type ProjectSearchFormType,
  initialValueOfProjectSearchForm,
} from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { SheetTypeLabelModifier, sheetTypeEnum } from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const SheetTypeColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<ProjectSearchFormType>();
  const currentFiscalYear = useCurrentFiscalYear();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="sheetType"
        label={t('sheet-type')}
        hint={t('hint-search-sheet-type')}
        control={control}
        errors={errors}
        options={sheetTypeEnum.options.map((value) => ({
          value,
          label: SheetTypeLabelModifier[value],
        }))}
        shouldCoexistOnChange
        onChange={(value) => {
          if (value === 'KS') {
            setValue('fundSheetType', 'standard');
          }
          if (value === 'RS') {
            setValue('skipAdministrativeReformTeamEvaluation', 'false');
          }
          if (value !== 'RS') {
            setValue('nestedExpenditureBudgetPurposeIds', null);
            setValue('nestedPolicyIds', null);
            setValue('formulaConditions', [
              initialValueOfProjectSearchForm(
                currentFiscalYear.data ?? currentFiscalYear.basicFiscalYear,
              ).formulaConditions,
            ]);
          }
        }}
        allowClear={false}
      />
    </Col>
  );
});
